module.exports = "data:image/jpeg;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJpbWcvdGlja2V0LXRyYW5zYWNjaW9uLjhmMTliOTliLmpwZyI7"